module.exports = __webpack_public_path__ + "img/license_image9.571afceb.png";